import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { organismos_item } from "../../json/organismos";
import "./stylessh.css";

const Organismos = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSelectChange = (event, url) => {
    const selectedUrl = event.target.value;
    if (selectedUrl) {
      window.open(selectedUrl, "_blank");
    }
  };

  return (
    <div className="container transparencia-container">
      <div className="row">
        <div className="col-12">
          <div className="transparencia_title">
            <h1>Organismos y Órganos</h1>
            <hr className="tramitehr" />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          {organismos_item.map((seccion, index) => (
            <div key={index}>
              <h2>{seccion.organismos_item_titulo_seccion}</h2>
              <div className="row">
                {seccion.organismos_item_seccion.map((item, itemIndex) => (
                  <div key={itemIndex} className="col-sm-4">
                    <div className="card card-look">
                      <br />
                      {Array.isArray(item.organismos_item_url) ? (
                        <>
                          <h3 className="text-center">{item.organismos_item_card_title}</h3>
                          <br />
                          <p className="card-info">{item.organismos_item_card_text}</p>
                          <select
                            className="form-select text-center select-wi form-floating w-100 px-3"
                            onChange={(event) => handleSelectChange(event, item.organismos_item_card_title)}
                          >
                            {item.organismos_item_url.map((option, optionIndex) => (
                              <option key={optionIndex} value={option.url}>
                                {option.label}
                              </option>
                            ))}
                          </select>
                        </>
                      ) : (
                        <>
                          <h3 className="text-center">{item.organismos_item_nombre}</h3>
                          <br />
                          <p className="card-info">{item.organismos_item_titulo}</p>
                          <Link to={item.organismos_item_url.url} target="_blank" rel="noopener noreferrer" className="reference-padding">
                            {item.organismos_item_url.label}
                          </Link>
                        </>
                      )}
                    </div>
                  </div>
                ))}
              </div>
              <br></br><br></br>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Organismos;
